import { FundriseRouteConfig } from 'vue-router';

const feeWaiverRoutes: FundriseRouteConfig[] = [
	{
		path: '/fee-waiver/claim',
		name: 'fee-waiver-claim',
		meta: { minTokenScopeRequired: 'FULL_ACCESS' },
		component: () => import('@views/marketing-site/fee-waiver-claim.vue')
	}
];

export default feeWaiverRoutes;
